// eslint-disable-next-line import/prefer-default-export
export const TYPES = {
	CANCEL: 'CANCEL',
	VOID: 'VOID',
};
